import { render, staticRenderFns } from "./terms-conditions-modal.vue?vue&type=template&id=5218e300&scoped=true"
import script from "./terms-conditions-modal.vue?vue&type=script&lang=js"
export * from "./terms-conditions-modal.vue?vue&type=script&lang=js"
import style0 from "./terms-conditions-modal.vue?vue&type=style&index=0&id=5218e300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5218e300",
  null
  
)

export default component.exports